module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAAlklEQVQoka2T0QnDMBBD5WzRrwzSLJCsnSwSKPYYrz8xOS5nakwF9yOdbCFjAXJzEGP3uwmQA5KSJyN+Cpa6EZmjW0N+krRKyles3smS1gRkSa+B1EWmzSVoPpqlGqy5imfDZHkAEvdb1UJ6nopa2DD+bj4bu09+oO23bTibA+bGp4j0ImADyg+TxwfYbJz9Eo5G3If+Balajl5LjPxdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/routeDetail-btn1.png
// module id = qwyZ
// module chunks = 1